<template>
  <div>
    <!-- 这个组件是按照最新的方式重新写 -->
    <el-button
      type="primary"
      @click="btnClick"
      :loading="loading"
      icon="el-icon-download"
      size="small"
      >导出</el-button
    >
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import FormatJson from "@/util/lead-out/FormatJson";
import { export_json_to_excel } from "@/util/lead-out/Export2Excel";
import _ from "lodash";
export default {
  // inject: ["leadOutFun"],
  name: "lead-out-new",
  props: {
    name: {
      type: String,
    },
    column: {
      type: Array,
    },
    params: {
      type: Object,
    },
    api: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    btnClick() {
      this.loading = true;
      this.$emit("click", this.onLeadOutApi());
    },
    onLeadOutApi() {
      return {
        success: (res) => {
          if (!res) return (this.loading = false);
          const { column } = this;
          let _column = _.cloneDeep(column);
          // 不需要操作这一栏
          const idx = _column.findIndex((el) => el.label == "操作");
          if (idx > -1) {
            _column.splice(idx, 1);
          }
          // 导出操作
          const menu = this.$route.meta.name;
          const tHeader = _column.map((v) => v.label);
          const filter = _column.map((v) => v.prop);
          const _data = FormatJson(filter, res);
          export_json_to_excel(tHeader, _data, `${menu}`);
          this.loading = false;
        },
        fail: (obj = {}) => {
          this.$message.error(obj.msg || "未查询到导出数据，请重试！");
          this.loading = false;
        },
      };
    },
  },
};
</script>

<style></style>
